import React, { useState, useEffect } from "react";
import "../styles/Gallery2.scss";

import g1 from "../assets/gallery/3D Gallery/1 (1).webp";
import g2 from "../assets/gallery/3D Gallery/1 (2).webp";
import g3 from "../assets/gallery/3D Gallery/1 (3).webp";
import g4 from "../assets/gallery/3D Gallery/Club (1).webp";
import img1 from "../assets/gallery/3D Gallery/Club.webp";
import img2 from "../assets/gallery/3D Gallery/Hall (1).webp";
import img3 from "../assets/gallery/3D Gallery/Hall.webp";
import img4 from "../assets/gallery/3D Gallery/Villa01.webp";

import img5 from '../assets/gallery/3D Gallery/Villa_1.webp';
import img6 from '../assets/gallery/3D Gallery/Villas (1).webp';

import img7 from '../assets/gallery/3D Gallery/Villas.webp';
import img8 from '../assets/gallery/3D Gallery/1.webp';

const Gallery2 = () => {
    const slides = [
        {
            image: img8,
            title: "Morning Walks",
        },
        {
            image: g2,
            title: "Wide Internal Roads",
        },
        {
            image: g3,
            title: "Yoga & Wellness",
        },
        {
            image: g4,
            title: "Luxury Living",
        },
        {
            image: img1,
            title: "Nature Views",
        },
        {
            image: img2,
            title: "Premium Villas",
        },
        {
            image: img3,
            title: "Misty Waterfalls",
        },
        {
            image: img4,
            title: "Peaceful Living",
        },
        {
            image: img5,
            title: "Peaceful Living",
        },
        {
            image: img6,
            title: "Peaceful Living",
        },
        {
            image: img7,
            title: "Peaceful Living",
        },
        {
            image: g1,
            title: "Peaceful Living",
        },
        
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [activeIndex]);

    const nextSlide = () => {
        setActiveIndex((prev) =>
            prev === slides.length - 1 ? 0 : prev + 1
        );
    };

    const prevSlide = () => {
        setActiveIndex((prev) =>
            prev === 0 ? slides.length - 1 : prev - 1
        );
    };

    return (
        <section className="lv-gallery" id="gallery">

            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`gallery-slide ${index === activeIndex ? "active" : ""
                        }`}
                >
                    <img src={slide.image} alt={slide.title} />
                </div>
            ))}

            <div className="gallery-overlay"></div>

            <div className="gallery-content">

                <span className="gallery-kicker">
                    FRAMED BY NATURE
                </span>

                <h2>
                    Experience
                    <span> Lonavalley</span>
                </h2>

                <p>
                    Discover breathtaking landscapes,
                    premium infrastructure,
                    and resort-style living in the heart of nature.
                </p>

            </div>

            <button
                className="gallery-arrow prev"
                onClick={prevSlide}
            >
                ‹
            </button>

            <button
                className="gallery-arrow next"
                onClick={nextSlide}
            >
                ›
            </button>

            <div className="gallery-dots">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setActiveIndex(index)}
                        className={
                            activeIndex === index
                                ? "dot active"
                                : "dot"
                        }
                    />
                ))}
            </div>

            <div className="gallery-thumbs">
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`thumb ${activeIndex === index
                            ? "active"
                            : ""
                            }`}
                        onClick={() =>
                            setActiveIndex(index)
                        }
                    >
                        <img
                            src={slide.image}
                            alt={slide.title}
                        />
                    </div>
                ))}
            </div>

        </section>
    );
};

export default Gallery2;